module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-bread-cumb', {
    attrs: {
      "bread-cumb": _vm.breadCumb
    }
  }), _vm._v(" "), _c('div', {}, [_c('el-form', {
    ref: "noticeForm",
    attrs: {
      "model": _vm.noticeForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.noticeForm.title),
      callback: function($$v) {
        _vm.$set(_vm.noticeForm, "title", $$v)
      },
      expression: "noticeForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "notice"
    }
  }, [_c('editor', {
    on: {
      "callback": _vm.receiveContent
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "end_time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "请选择结束时间"
    },
    model: {
      value: (_vm.noticeForm.end_time),
      callback: function($$v) {
        _vm.$set(_vm.noticeForm, "end_time", $$v)
      },
      expression: "noticeForm.end_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.noticeForm.status),
      callback: function($$v) {
        _vm.$set(_vm.noticeForm, "status", $$v)
      },
      expression: "noticeForm.status"
    }
  }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.noticeForm.status),
      callback: function($$v) {
        _vm.$set(_vm.noticeForm, "status", $$v)
      },
      expression: "noticeForm.status"
    }
  }, [_vm._v("不显示")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('noticeForm')
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('noticeForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502f201e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/system/notice/add.vue
// module id = 873
// module chunks = 0